export enum CONFIRMATION_MODAL_TYPE {
  ERROR = 'error',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  PRIMARY = 'primary'
}

export const COLOR = {
  [CONFIRMATION_MODAL_TYPE.ERROR]: 'error',
  [CONFIRMATION_MODAL_TYPE.INFO]: 'info',
  [CONFIRMATION_MODAL_TYPE.SUCCESS]: 'success',
  [CONFIRMATION_MODAL_TYPE.WARNING]: 'error',
  [CONFIRMATION_MODAL_TYPE.PRIMARY]: 'primary'
} as const;